import { useMemo } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import { getFormattedThousand } from "@datassential/platform-ui-lib";
import { COMMON_NUM_COL_WIDTH } from "@core/constants";


export function useBaseSizeTableCell(data: Array<{ base: number }>) {
    return useMemo(
        (): TableColumn => ({
            key: 'baseSize',
            head: 'Base',
            headText: 'Base Size',
            Value: ({ index }) => (<>
                {getFormattedThousand(data[index]?.base)}
            </>),
            valueText: (index) => `${data[index].base}`,
            style: {
                cell: {
                    justifyContent: 'center',
                    flex: `0 0 ${COMMON_NUM_COL_WIDTH}`,
                },
            },
        }),
        [data]
    );
}